import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

//= ========================================================================

const MyMessagePopup = ({
  onOkPressed,
  okTitle,
  message,
}) => {
  const myStyles = ({
    text: {
      width: 338,
      fontFamily: 'Rubik-Regular',
      fontSize: 16,
      textAlign: 'center',
      color: '#001a2f',
      position: 'absolute',
      marginTop: 30,
      marginLeft: 30,
      marginRight: 30,
    },
    container: {
      width: 464,
      height: 242,
      justifyContent: 'center',
      position: 'fixed',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 100,
      marginTop: 120,
    },
    subContainer: {
      width: 400,
      height: 200,
      alignSelf: 'center',
      backgroundColor: '#d9d9d9',
      borderRadius: 8,
      shadowColor: '#000',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.22,
      shadowRadius: 12,
    },
    messageContainer: {
      width: 398,
      height: 198,
      position: 'absolute',
      flexDirection: 'column',
      margin: 1,
      backgroundColor: '#fff',
      borderRadius: 6,
    },
    buttonContainer: {
      marginLeft: 149,
      marginTop: 140,
      width: 100,
      height: 36,
      position: 'absolute',
      flexDirection: 'row',
    },
    button: {
      width: 100,
      height: 36,
      backgroundColor: '#008cff',
      borderRadius: 8,
    },
    okContainer: {
      width: 96,
      height: 32,
      position: 'absolute',
      margin: 2,
      backgroundColor: '#fff',
      borderRadius: 6,
    },
    okText: {
      fontFamily: 'Rubik-Regular',
      fontSize: 16,
      textAlign: 'center',
      color: '#001a2f',
      position: 'absolute',
      marginTop: 7,
      width: 96,
    },
  });

  return (
    <View style={myStyles.container}>
      <View style={myStyles.subContainer}>
        <View style={myStyles.messageContainer}>
          <Text style={myStyles.text}>{message}</Text>
          <View style={myStyles.buttonContainer}>
            <TouchableOpacity
              style={myStyles.button}
              onPress={() => {
                onOkPressed();
              }}
            >
              <View style={myStyles.okContainer}>
                <Text style={myStyles.okText}>{okTitle}</Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

export default MyMessagePopup;
